/* eslint-disable no-console, eol-last, import/no-duplicates,  import/no-extraneous-dependencies, import/order */
import '@interactjs/pointer-events/plugin'
import interact from '@interactjs/interact/index'
import plugin from '@interactjs/pointer-events/plugin'
interact.use(plugin)